import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.acti_user_assigned_uid !== model.acti_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.acti_user_modified_uid,
						assignedTo: modifiedModel.acti_user_assigned_uid,
						title: 'Nuova Attività assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.acti_title}".`,
						url: `${window.location.origin}/activities/details/${model.acti_uid}`,
						icon: 'puzzle-outline',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
